import { editorialCategoryType } from '@/lib/sponsors';
import classNames from '@/utils/className';

interface WrapperProps {
  backgroundColor?: string;
  isOnHeader?: boolean;
  // Cor de fundo da editoria (data-driven, vinda do Directus). Quando presente,
  // vence o `backgroundColor` Tailwind via inline style. `null`/ausente → tema neutro.
  themeBg?: string | null;
  // Fallback legado por marca (sub-categorias sem identidade data-driven).
  editorialCategory?: editorialCategoryType;
  children: JSX.Element[] | JSX.Element;
  paddingOnlyTop?: boolean;
}

const LEGACY_BG: Record<editorialCategoryType, string> = {
  ctup: 'bg-ctupBlue',
  eletro: 'bg-cteletroBlack',
  ctauto: 'bg-ctautoRed',
};

export default function WrapperDestaque({
  children,
  backgroundColor = 'bg-mglGray50',
  isOnHeader,
  themeBg = undefined,
  editorialCategory = undefined,
  paddingOnlyTop = false,
}: WrapperProps) {
  const legacyBg = !themeBg && editorialCategory ? LEGACY_BG[editorialCategory] : undefined;

  return (
    <section
      style={themeBg ? { backgroundColor: themeBg } : undefined}
      className={classNames(
        'flex w-full flex-col flex-wrap content-center justify-center p-0 [&_.swiper-container]:w-full [&_.swiper-container]:py-0',
        isOnHeader && 'p-0 py-0',
        !isOnHeader && !paddingOnlyTop && 'p-0 py-6',
        legacyBg ?? backgroundColor,
        paddingOnlyTop && 'p-0 py-0 pt-10',
        !paddingOnlyTop && '[&_.swiper-container]:px-6'
      )}>
      <div className="ml-0 w-full">{children}</div>
    </section>
  );
}
